var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileExperienceInner.jinja');
require('./MemberProfileExperienceInner.less');

var MemberProfileButtonsEdit = require('front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        this.MemberProfileButtonsEdit = new MemberProfileButtonsEdit({
            el: this.$el.parent().find('.MemberProfileButtonsEdit')[0]
        });

        Base.prototype.initialize.call(this, options);
    },

    deactivate: function (params) {
        this.MemberProfileButtonsEdit.deactivate();
        delete this.MemberProfileButtonsEdit;

        return Base.prototype.deactivate.call(this, params);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileExperienceInner.js
// module id = 195
// module chunks = 0